<template>

<div>
    <button class="mb-2" v-on:click="gerarf2b">Gerar Cobrança F2b (Boleto, debito ou pix) </button> 
    <b-spinner v-show="loading" variant="success" ></b-spinner>
    <div ref="paypal"></div>
    <div v-if="cobgerada">
        <b-alert variant="success" show> 
            Este mesmo link <b-link :href="linkf2b" target="_blank"> {{linkf2b}} </b-link> foi enviado pro seu email.
        </b-alert>
	</div>
</div>

</template>

<script>
import { mapGetters } from "vuex";
export default {
    data: function() {
        return {
        loading:false,  
        cobgerada: false,
        linkf2b:''
        }  
    },
    computed: {
        ...mapGetters({
            itensCarrinho: "getCartItems",
            Total:'getTotalCarrinho',
            TotalDesc:'getDescontoCarrinho',
            QtdCarrinho:'getQtdCarrinho',
            PerCupom:'getPerCupom',
            ClientId:'getClientId',
            emailpaypal:'getEmailPaypal'
        }),
         VlrCupom() {
            if (this.PerCupom < 0) {
                    return 0
            } else {
                return (this.Total - this.TotalDesc) * this.PerCupom / 100    
            }
        },
        ComDesc() {
        return this.Total - this.TotalDesc
        },
         Liquido() {
            return this.Total - this.TotalDesc - this.VlrCupom
        }
   },
   methods: {
       gerarf2b() {
            this.loading = true
            const url = process.env.VUE_APP_BACKEND +'AprovePaypal.php'
            let dados = "clientid="+this.ClientId
                dados += '&gateway=2'
                dados += '&total='+this.Total
                dados += '&cupomid='+this.CupomId
                dados += '&vlrcupom='+this.VlrCupom
                dados += '&vlrliquido='+this.Liquido
                dados += '&qtditens='+this.QtdCarrinho
                let extra = this.VlrCupom + this.TotalDesc
                if (extra > 0) {
                    extra = extra * -1
                    dados += '&extraAmount='+extra
                }
                for (let i = 0; i < this.itensCarrinho.length; i++) {
                            let item = this.itensCarrinho[i]
                            let indice = i + 1
                            dados += '&itemId'+indice+'='+item.id
                            dados += '&itemDescription'+indice+'='+item.title
                            dados += '&itemAmount'+indice+'='+item.price
                            dados += '&itemQuantity'+indice+'='+item.quantity
                }
                fetch(url,{
                            method: "POST",
                            headers: { "Content-Type":"application/x-www-form-urlencoded" },
                            body: dados
                        })
                         .then((response) => {
                                if (response.ok) {
                                
                                    return response.json();
                            }
                            })
                            .then((json) => {
                                    this.loading = false
                                    if (json.status == 'sucesso') {
                                        this.$store.commit('setPdId',json.id)
                                        this.linkf2b = json.message
                                        this.cobgerada = true
                                    } else {
                                        alert(json.message)
                                    }
                            })
                            .catch(function (error) {
                                console.log(error);
                            })


        }
   },
   watch: {
        cobgerada: function(newValue) {
           if (newValue) {
               const h = this.$createElement
        // Using HTML string
        const titleVNode = h('div', { domProps: { innerHTML: 'Cobrança F2b' } })

                       // More complex structure
        const messageVNode = h('div', { class: ['foobar'] }, [
          h('p', { class: ['text-center'] }, [
            ' Clique no  ',

           h('b-link',{ 
                props: { 
                    href: this.linkf2b,
                    target:'_blank'
                } },'Link de Cobrança Gerado'),
           ]),

            'e será direcionado para o site Cobrança F2b. Lá poderá escolher pagar no pix, debito ou gerar boleto. Se clicar no botão Gerar Boleto será registrado no sistema bancario em até 2 horas, quando poderá efetuar o pagamento ',
            ])

 // We must pass the generated VNodes as arrays
        this.$bvModal.msgBoxOk([messageVNode], {
          title: [titleVNode],
          buttonSize: 'sm',
          centered: true, size: 'sm'
        })
         
        
       
            }
       }
   }

}
</script>

<style scoped>

</style>